import React, { Fragment, useState, useCallback } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { usePopper } from 'react-popper';
import { Box, Text } from 'roo-ui/components';
import theme from 'lib/theme';

const TooltipContent = styled(Box)`
  transition: opacity 0.1s linear 0.25s;
  opacity: ${(props) => (props.isOpen ? '1' : '0')};
`;

const Tooltip = ({ label, children, modifiers, zIndex }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, { modifiers });

  const showTooltip = useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  const hideTooltip = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  return (
    <Fragment>
      <Box ref={setReferenceElement} onMouseOver={showTooltip} onFocus={showTooltip} onMouseOut={hideTooltip} onBlur={hideTooltip}>
        {children}
      </Box>
      {isOpen && (
        <TooltipContent ref={setPopperElement} pt={1} style={styles.popper} {...attributes.popper} isOpen={isOpen} zIndex={zIndex}>
          <Box as={Text} fontSize="xs" bg="greys.steel" px={3} py={1} color="white" borderRadius="default">
            {label}
          </Box>
        </TooltipContent>
      )}
    </Fragment>
  );
};

Tooltip.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  modifiers: PropTypes.shape({}),
  zIndex: PropTypes.number,
};

Tooltip.defaultProps = {
  modifiers: {},
  zIndex: theme.zIndices.tooltip,
};

export default Tooltip;
